var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_4272)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.07923 2.99124C2.79764 2.99124 2.56937 3.21952 2.56937 3.5011V11.059C2.56937 11.3406 2.79764 11.5688 3.07923 11.5688H10.6371C10.9187 11.5688 11.147 11.3406 11.147 11.059V3.5011C11.147 3.21952 10.9187 2.99124 10.6371 2.99124H3.07923ZM1.42969 3.5011C1.42969 2.59009 2.16821 1.85156 3.07923 1.85156H10.6371C11.5481 1.85156 12.2867 2.59009 12.2867 3.5011V11.059C12.2867 11.97 11.5481 12.7085 10.6371 12.7085H3.07923C2.16821 12.7085 1.42969 11.97 1.42969 11.059V3.5011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02297 0.771484C9.33768 0.771484 9.59281 1.02661 9.59281 1.34133V3.50072C9.59281 3.81544 9.33768 4.07056 9.02297 4.07056C8.70825 4.07056 8.45312 3.81544 8.45312 3.50072V1.34133C8.45312 1.02661 8.70825 0.771484 9.02297 0.771484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69484 0.771484C5.00956 0.771484 5.26468 1.02661 5.26468 1.34133V3.50072C5.26468 3.81544 5.00956 4.07056 4.69484 4.07056C4.38013 4.07056 4.125 3.81544 4.125 3.50072V1.34133C4.125 1.02661 4.38013 0.771484 4.69484 0.771484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42969 5.65968C1.42969 5.34497 1.68481 5.08984 1.99953 5.08984H11.7168C12.0315 5.08984 12.2867 5.34497 12.2867 5.65968C12.2867 5.9744 12.0315 6.22953 11.7168 6.22953H1.99953C1.68481 6.22953 1.42969 5.9744 1.42969 5.65968Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_4272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9564,
    height: 12.9564,
    fill: "white",
    transform: "translate(0.382812 0.261719)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e6961b1af2533838579bda3ede748c67.svg";
export { ForwardRef as ReactComponent };